import React, { Component } from 'react'
import { reduxForm, formValueSelector, change } from 'redux-form'
import { connect } from 'react-redux'
import moment from 'moment'
import * as _ from 'lodash'
import Loader from 'react-loader'
import SelectField from '../shared/SelectField'
import { transformFaculties, transformYears, transformEducationYear, MONTHS as months } from '../../utils/const'
import { getCurrentYear } from '../../utils/getItemFromRange'
import NoData from '../../assets/NoData/NoData'
import styles from './Schedule.module.css'

const selector = formValueSelector('schedule')

class Schedule extends Component {
  state = {
    isLoaded: false,
    teacher: '',
  }

  _groupNeedsInit = false
  componentDidMount() {
    const { fetchYears, fetchEducationYear, fetchFaculty, fetchLkData } = this.props
    fetchYears()
    fetchEducationYear()
    fetchLkData()
    fetchFaculty()
    window.scrollTo(0, 0)
    this.setInitialValues()
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isLoaded && nextProps.yearsList.length && nextProps.educationYear.length && !_.isEmpty(nextProps.lkData)) {
      this.setState({ isLoaded: true })
    }
    // if (!_.isEqual(nextProps.myValues.year, this.props.myValues.year) && this.props.myValues.year) {
    //   const course = nextProps.lkData.yeducationyearid
    //   const yearNow = moment(getCurrentYear(this.props.yearsList).begdate).year()
    //   const yearCurrent = moment(this.props.yearsList.find(it => it.xp_key==nextProps.myValues.year).begdate).year()
    //   const newCourse = course - (yearNow - yearCurrent)>=1 ? course - (yearNow - yearCurrent) : course
    //   this.props.change("educationYear", newCourse)
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    const { myValues, fetchSchedule, schedule, getGroup, isTeacher, lkData, groupsSchedule } = this.props
    const { faculty, educationYear, year, month, group } = myValues;

    if (!prevState.isLoaded && this.state.isLoaded) {
      this.setInitialValues()
    }
    if (!prevProps.facultyList.length && this.props.facultyList.length) {
      this.setInitialValues()
    }
    // Обновление списка групп при изменении факультета, курса или учебного года
    const facultyChanged = prevProps.myValues.faculty !== myValues.faculty
    const educationYearChanged = prevProps.myValues.educationYear !== myValues.educationYear
    const yearChanged = prevProps.myValues.year !== myValues.year
    if ((facultyChanged || educationYearChanged || yearChanged) && faculty !== undefined && educationYear !== undefined && year) {
      getGroup(myValues)
      // Сбрасываем group в 0 (Все) только если не ожидаем первичную установку группы обучающегося
      if (!this._groupNeedsInit) {
        this.props.change('group', '0')
      }
    }

    // После загрузки списка групп устанавливаем группу обучающегося
    if (!isTeacher && this._groupNeedsInit && prevProps.groupsSchedule !== groupsSchedule) {
      const studentGroupName = lkData.groupname
      const matchingGroup = groupsSchedule.find(g =>
        (g.groupname || g.name) === studentGroupName
      )
      this.props.change('group', matchingGroup ? String(matchingGroup.gid) : '0')
      this._groupNeedsInit = false
    }
  }
  componentWillUnmount() {
    this.props.setInitialScehedule()
  }

  setInitialValues = () => {
    const { initialize, lkData, isTeacher, yearsList, facultyList, educationYear: educationYearList } = this.props
    const currentYear = getCurrentYear(yearsList)
    const faculty = !isTeacher && lkData.facultyid ? lkData.facultyid : (facultyList.length ? facultyList[0].idfaculty : null)
    const year = currentYear?.xp_key || yearsList[yearsList.length - 1]?.xp_key
    // Для постоянного состава - всегда "Все" (0)
    // Для обучающегося - ищем курс по текстовому значению из профиля или "Все" (0)
    const studentCourse = !isTeacher && lkData.yeducationyear
      ? educationYearList.find(ey => ey.name === lkData.yeducationyear)
      : null
    const educationYear = isTeacher ? 0 : (studentCourse ? studentCourse.eyid : 0)
    const month = moment().month() + 1

    initialize({
      faculty,
      educationYear,
      year,
      month,
    })

    if (!isTeacher) {
      this._groupNeedsInit = true
    }
  }

  fetchSchedule = () => {
    const { myValues, fetchSchedule, schedule } = this.props
    const { faculty, educationYear, year, month, group } = myValues;
    (faculty !== undefined && educationYear !== undefined && year && month) && fetchSchedule(faculty, educationYear, year, month, group)
    //проверочные запросы
    //  fetchSchedule(3,3,32,11) //ПЕНЗА
    // fetchSchedule(0,1,34,11) //ПЕНЗА
    // fetchSchedule(0,3,32,7) //ПЕНЗА
    // fetchSchedule(0,2,32,7) ПЕНЗА
    // fetchSchedule(0,2,39,5) // СТАДИУМ СЛУЧАЙ С КРАЙНИМ ПУСТЫМ

  }

  checkDupl = (el, i, groups2) => {

    return (!!el[0]?.teachers && el[0]?.teachers === groups2[i - 1]?.[0]?.teachers) &&
      (!!el[0]?.rooms && el[0]?.rooms === groups2[i - 1]?.[0]?.rooms) &&
      (!!el[0]?.lessontype_name && el[0]?.lessontype_name === groups2[i - 1]?.[0]?.lessontype_name) &&
      (!!el[0]?.course_title && el[0]?.course_title === groups2[i - 1]?.[0]?.course_title)
  }

  renderSchedule(schedule) {

    const { groups } = this.props

    const rows = []
    _.forOwn(schedule, day =>
      _.forOwn(day, (lessons, lecture,) => {
        const keys = Object.keys(day)
        const oneDay = Object.keys(schedule).map(el => (moment(el).format("DD  MMM")))
        const lessonsWithoutKR = lessons.filter(el => el[0].course_title !== null) // контр-е работы не имеют teachers:null, course_title:null из-за этого создают доп клетку
        const groups11 = Object.values(groups).map((eel, i) => lessonsWithoutKR.find(el => el[0].groupname === eel) || []) // список наполненный отсутствующими уроками
        const groups2 = groups11.map((el, i) =>
          el?.length
            ? el.map(lesson => ({ ...lesson, index: i }))
            : [{ index: i }]
        )

        const duplicateLessonIndex = groups2.map((el, i) =>
          el.length && this.checkDupl(el, i, groups2)
            ? groups2.indexOf(el) : el) // список с индексами повторяющихся уроков

        const lessonsWithoutRepeat = groups2.filter((ele, i) => i !== duplicateLessonIndex.find(el => el !== 0 && el === i)) // список без повторяющихся уроков

        const row =
          !!lessons.length &&
          < tr >
            {/* день */}
            {
              lecture === keys[0] && (
                <td className='tg-s6z2' rowSpan={keys.length} style={{ width: '70px', position: 'sticky', left: '0px', backgroundColor: 'white' }}>
                  {moment(lessons[0][0].lessondate).format("DD  MMM")}
                  <br />
                  {moment(lessons[0][0].lessondate).format("ddd")}
                </td>
              )
            }
            {/* уроки и время */}
            <td className='tg-s6z2' style={{ position: 'sticky', left: '74px', backgroundColor: 'white' }}>
              {lessons[0][0].period_name}
              <br />
              {/* ({lessons[0][0].period_time}) */}
              ({(lessons[0][0].period_time).split(' ').join('')})
            </td>
            {/*курс и группа  */}
            {
              lessonsWithoutRepeat.map((lesson, indexLes) => {

                const colSpan = lessonsWithoutRepeat[indexLes + 1] !== undefined ? lessonsWithoutRepeat[indexLes + 1]?.[0]?.index - lesson[0]?.index : groups2.length - lesson[0]?.index

                return (
                  lesson[0]?.course_title ?
                    <td
                      key={indexLes}
                      className='tg-s6z2'
                      colSpan={colSpan}
                      style={{ minWidth: '200px' }}
                    >
                      {lesson.map((les, lesIdx) => {
                        const lesSubCour = ((les.subject_index || les.subject_title) && les.tema_num)
                          ? `${les.subject_index || les.subject_title} / ${les.tema_num}`
                          : (les.subject_index || les.subject_title)
                            ? `${les.subject_index || les.subject_title}`
                            : les.tema_num
                              ? `${les.tema_num}`
                              : null
                        return (
                          <React.Fragment key={lesIdx}>
                            {lesIdx > 0 && <hr style={{ margin: '4px 0' }} />}
                            {les.course_alias} <br />
                            {les.lessontype_alias} {!!lesSubCour && lesSubCour} <br />
                            {les.rooms} <br />
                            {les.teachers || 'Внешний'}
                          </React.Fragment>
                        )
                      })}
                    </td>
                    :
                    <td >
                    </td>
                )
              })

            }
          </tr >


        if (!!row) rows.push(row)
      })
    )
    return !!rows.length ? rows :
      <tr colSpan='3' >
        <NoData text='данные отсутствуют' />
      </tr>
  }

  renderGroup = (group, index) => (

    <th key={index} className='tg-tegg'>
      {group} группа
    </th>
  )

  render() {
    const { isLoading, facultyList, yearsList, educationYear, edyId, schedule, groupsSchedule, groups } = this.props
    const faculties = transformFaculties(facultyList)
    const years = transformYears(yearsList)
    const edYear = transformEducationYear(educationYear)
    const chosenEdYear = edYear.find(element => element.value === Number(edyId)) || '1 курс'
    const header = 'Расписание занятий'

    return (
      <div className='upper schedule__pictures' >

        <div className='captions' style={{ margin: '0px' }}>{header}</div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }}>
              <SelectField className='schedule__select-left' name='faculty' label='Факультет ' options={
                [{ name: 'Все', value: '0' },
                ...faculties]
              } />
            </div>
            <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }} >
              <div className='inputs__input inputs__input_schedule_small'>
                <SelectField className='schedule__select' name='educationYear' options={[{ name: 'Все', value: 0 }, ...edYear]} label='Курс (рота) ' />
              </div>
            </div>
            <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }}>
              <div className='inputs__input inputs__input_schedule_small'>
                <SelectField className='schedule__select' name='year' options={years} label='Учебный год ' />
              </div>
            </div>
            <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }}>
              <div className='inputs__input inputs__input_schedule_small'>
                <SelectField className='schedule__select' name='month' options={months} label='Месяц' />
              </div>
            </div>
            <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }}>
              <div className='inputs__input inputs__input_schedule_small'>
                <SelectField className='schedule__select' name='group' label='Группа' options={
                  [{ name: 'Все', gid: '0' },
                  ...groupsSchedule]
                } />
              </div>
            </div>
          </div>

          <button className={styles.button} onClick={this.fetchSchedule}>
            Обновить
          </button>

        </div>
        {isLoading ? <Loader loaded={!isLoading} color='#7b2b2a' /> :
          schedule && (
            !_.isEmpty(schedule) ?
              <div className='schedule__scroll'>
                <table className='schedule'>
                  <thead style={{ zIndex: '10' }}>
                    <tr>
                      <th className='tg-s6z2' rowSpan='2' style={{ position: 'sticky', left: '0px' }}>
                        Дата
                      </th>
                      <th className='tg-s6z2' rowSpan='2' style={{ position: 'sticky', left: '74px' }}>
                        Часы занятий
                      </th>
                      <th className='tg-70w9' colSpan={Object.keys(groups).length}>
                        {chosenEdYear.name}
                      </th>
                    </tr>
                    <tr>{Object.values(groups).map(this.renderGroup)}</tr>
                  </thead>
                  <tbody>{this.renderSchedule(schedule)}</tbody>
                </table>
              </div> : <NoData text='данные отсутствуют' />
          )
        }
      </div>
    )
  }
}

const scheduleForm = reduxForm({
  form: 'schedule',
})(Schedule)

export default connect(state => ({
  myValues: selector(state, 'faculty', 'educationYear', 'year', 'month', 'group'),
}), { change })(scheduleForm)